<div id="financialPointsForm" class="viewing" data-automation="financialPointContainer">
    <mat-expansion-panel
        (opened)="panelOpenedState = true"
        (closed)="panelOpenedState = false"
        togglePosition="before"
        class="expansion-panel financial-panel_{{ index }}"
    >
        <mat-expansion-panel-header
            class="panel-override"
            collapsedHeight="74px"
            expandedHeight="48px"
            data-automation="financialPointHeader"
        >
            <mat-panel-title class="point-title">
                <div data-automation="displayLabel">
                    {{ displayLabel }}
                </div>
            </mat-panel-title>
            <mat-panel-description class="point-subtitle">
                {{ panelOpenedState ? '' : point.priceType || '' }}
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="panel-override">
            <!-- Name -->
            <div class="form-entry">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ 'registration.financial_point.name' | translate }}</mat-label>
                    <input matInput disabled data-automation="financialPointName" [value]="displayLabel" />
                </mat-form-field>
            </div>

            <!-- Price Type -->
            <div class="form-entry">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ 'registration.financial_point.price_type' | translate }}</mat-label>
                    <input
                        matInput
                        disabled
                        data-automation="financialPointPriceType"
                        [value]="point.priceType || ''"
                    />
                </mat-form-field>
            </div>

            <!-- Source -->
            <div class="form-entry">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ 'registration.financial_point.source' | translate }}</mat-label>
                    <input matInput disabled data-automation="financialPointSource" [value]="point.source || ''" />
                </mat-form-field>
            </div>

            <!-- Data Provider -->
            <div class="form-entry">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ 'registration.financial_point.data_provider' | translate }}</mat-label>
                    <input matInput disabled data-automation="financialPointDataProvider" [value]="dataProvider" />
                </mat-form-field>
            </div>

            <!-- Channel -->
            <div class="form-entry">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ 'registration.financial_point.channel' | translate }}</mat-label>
                    <input matInput disabled data-automation="financialPointChannel" [value]="channel" />
                </mat-form-field>
            </div>

            <!-- Reporting Interval -->
            <div class="form-entry">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ 'registration.financial_point.reporting_interval' | translate }}</mat-label>
                    <input
                        matInput
                        disabled
                        data-automation="financialPointReportingInterval"
                        [value]="reportingInterval"
                    />
                </mat-form-field>
            </div>

            <!-- Multiplier -->
            <div class="form-entry">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ 'registration.financial_point.multiplier' | translate }}</mat-label>
                    <input
                        matInput
                        disabled
                        data-automation="financialPointMultiplier"
                        [value]="point.multiplier != null ? point.multiplier : ''"
                    />
                </mat-form-field>
            </div>

            <!-- Expression Factor -->
            <div class="form-entry">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ 'registration.financial_point.expression_factor' | translate }}</mat-label>
                    <input
                        matInput
                        disabled
                        data-automation="financialPointExpressionFactor"
                        [value]="point.expressionFactor != null ? point.expressionFactor : ''"
                    />
                </mat-form-field>
            </div>
        </div>
    </mat-expansion-panel>
</div>
